import {
  Box,
  Checkbox,
  Flex,
  Skeleton,
  Td,
  Text,
  Tr,
  useDisclosure,
} from '@chakra-ui/react'
import { Ellipsis } from 'brokertslib/src/components'
import {
  InsurerOrganizationUnit,
  InsurerOrganizationUnitDiscount,
} from 'BrokerTsLib/src/dtos'
import { useSetInsurerValid } from 'BrokerTsLib/src/hooks/useOrganizationUnit'
import { useEffect, useState } from 'react'

import { Discounts } from './Discounts'
import { DiscountsEdit } from './DiscountsEdit'

const getSortedDiscounts = (discounts: InsurerOrganizationUnitDiscount[]) =>
  discounts.toSorted((a, b) => {
    return b.maxDiscount - a.maxDiscount
  })

export const OrganizationDiscountTableRow = ({
  insurer,
  isEditDisabled,
  isFetching,
}: {
  insurer: InsurerOrganizationUnit
  isEditDisabled?: boolean
  isFetching?: boolean
}) => {
  const [activeDiscounts, setActiveDiscounts] = useState<
    InsurerOrganizationUnitDiscount[]
  >(getSortedDiscounts(insurer.activeDiscounts))
  const [isValid, setValid] = useState(insurer.valid)
  const { isOpen, onOpen, onClose } = useDisclosure()

  const { mutateAsync: setValidAsync, isLoading: isSetValidLoading } =
    useSetInsurerValid()

  const handleSetValid = (valid: boolean) => {
    setValidAsync({ ...insurer, valid })
    setValid(valid)
  }

  useEffect(() => setValid(insurer.valid), [insurer.valid])

  useEffect(
    () => setActiveDiscounts(getSortedDiscounts(insurer.activeDiscounts)),
    [insurer.activeDiscounts],
  )

  return (
    <Tr>
      <Td>
        <Box sx={{ display: 'grid', alignItems: 'center' }}>
          <Checkbox
            size="sm"
            isChecked={isValid}
            onChange={() => handleSetValid(!isValid)}
            disabled={isEditDisabled || isSetValidLoading}
          />
        </Box>
      </Td>
      <Td>
        <Ellipsis
          as={Text}
          sx={{
            fontSize: 'sm',
            fontWeight: 'medium',
            cursor: isEditDisabled ? 'auto' : 'pointer',
          }}
          onClick={onOpen}
          tooltipProps={{ trigger: 'hover' }}
        >
          {insurer.insurer}
        </Ellipsis>
      </Td>
      <Td>
        <Skeleton isLoaded={!isFetching}>
          <Flex
            sx={{
              w: '100%',
              justifyItems: 'space-between',
              gap: 2,
              fontSize: 'xs',
              flexFlow: 'wrap',
            }}
          >
            <Discounts
              discounts={activeDiscounts}
              onClick={onOpen}
              isDisabled={isEditDisabled}
            />
          </Flex>
        </Skeleton>
        {!isEditDisabled && (
          <DiscountsEdit insurer={insurer} isOpen={isOpen} onClose={onClose} />
        )}
      </Td>
    </Tr>
  )
}
